var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "minRowHeight flex flex-col mb-10",
      class: [
        _vm.containerClasses,
        this.additionalClass ? this.additionalClass : "",
      ],
    },
    [
      _vm.formattedLabel
        ? _c(
            "div",
            { class: _vm.labelDivClass },
            [
              _vm._t("label", function () {
                return [
                  _c(
                    "span",
                    {
                      staticClass:
                        "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg normal-case",
                      class: [_vm.generalClasses, _vm.labelClasses],
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.formattedLabel) + " "),
                      _vm.totalNumber
                        ? _c("span", { staticClass: "totalNumber ml-0.5" }, [
                            _vm._v("(" + _vm._s(_vm.totalNumber) + ")"),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]
              }),
              _vm.showExtra
                ? _c(
                    "span",
                    {
                      staticClass: "text-label mr-auto",
                      class: _vm.generalClasses,
                    },
                    [
                      _c("span", { staticClass: "mr-2" }, [
                        _vm._v("(" + _vm._s(_vm.itemExtraInfo) + ")"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._t(
        "default",
        function () {
          return [
            _c(
              "div",
              {
                class: [
                  _vm.contentContainerClass,
                  _vm.textClasses,
                  _vm.generalClasses,
                ],
              },
              [
                _c("p", { staticClass: "truncate" }, [
                  _vm._v(_vm._s(_vm.itemContent)),
                ]),
              ]
            ),
          ]
        },
        { textClasses: _vm.textClasses }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }